import '.ax{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.gt{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.aw{align-items:flex-start;}.ssr-plugin'
import '.dc{padding:2rem;}.ssr-plugin'
import '.dj{background:var(--palette-white);}.ssr-plugin'
import '.ao{overflow:hidden;}.ssr-plugin'
import '.bc{position:absolute;}.ssr-plugin'
import '.jb{top:50%;}.ssr-plugin'
import '.jc{right:1rem;}.ssr-plugin'
import '.jd{transform:translateY(-50%);}.ssr-plugin'
import '.je{width:120px;}.ssr-plugin'
import '.jf{height:120px;}.ssr-plugin'
import '.jg{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ih{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.jh{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ax n gt d e ad aw dc dj ao"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bc jb jc jd je jf jg d r ad"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ax ih d e aw s jh"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
